function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import RESTSerializer, { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
export default class Menu extends RESTSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      menuHours: {
        embedded: 'always'
      }
    });
  }
  keyForAttribute(attr) {
    return underscore(attr);
  }
  modelNameFromPayloadKey() {
    return 'menu-sync/menu';
  }
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (Object.keys(payload).length === 0) {
      // eslint-disable-next-line no-param-reassign
      payload.menus = [];
    }
    return super.normalizeResponse(store, primaryModelClass, payload, id, requestType);
  }
  serializeIntoHash(hash, type, record, options) {
    super.serializeIntoHash(hash, type, record, options);

    // eslint-disable-next-line no-param-reassign
    hash.menu = hash['menuSync/menu'];

    // eslint-disable-next-line no-param-reassign
    delete hash['menuSync/menu'];
  }
}